/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { useRef, useCallback, useState, useEffect } from "react";
import { CircularProgress } from "@material-ui/core";
import SmallLogo from "../../assets/images/logo-small-white.png";
import Label from "../../components/label";
import {
  clearParticularNotification,
  doctorNotifications
} from "../../apiRoutes";
import moment from "moment";
import ICButton from "../../components/button";
import appRoutes from "../../routes/appRoutes";
import { useHistory } from "react-router-dom";

export default function StickyHeadTable(props) {
  const history = useHistory();
  const observer = useRef();
  const [pageNo, setPageNumber] = useState(1);
  const [nextPage, setNextPage] = useState(false);
  const [loading, setLoading] = useState(true);
  const [progressBar, setProgressBar] = useState(false);
  const [limit] = useState(10);
  const [skipPrevData, setSkipPrevData] = useState(0);
  const [dataLoaded, setDataLoaded] = useState(false);

  // Data to be appended
  const [rows, setRows] = useState([]);
  const [appendRows, setAppendRows] = useState([]);

  const lastElementRef = useCallback(node => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(data => {
      if (data) {
        if (data[0].isIntersecting && nextPage && loading) {
          setLoading(false);
          if (loading) {
            setPageNumber(pageNo => pageNo + 1);
            let skipDataCalculation = limit * pageNo;
            setSkipPrevData(skipDataCalculation);
            getNotifications(limit, skipDataCalculation);
            setRows(rows.concat(appendRows));
          }
          // setTimeout(() => {
          //   setLoading(true);
          // }, 1000);
        }
      }
    });
    if (node) observer.current.observe(node);
  });

  const getNotifications = (limitPage, skipPage) => {
    setProgressBar(true);
    let apiCallParam = {
      reqType: "GET",
      reqURL: doctorNotifications,
      dataObj: {},
      params: {
        limit: limitPage,
        skip: skipPage,
        hasHistoryNotifications: props.enableHistoryNotificaitons || false
      },
      headers: {},
      successCallback: res => {
        if (skipPage === 0) {
          setRows(res.data.data.notifications);
        } else {
          setAppendRows(res.data.data.notifications);
        }
        if (!res.data.data.notifications.length) {
          setDataLoaded(true);
          setNextPage(false);
        }
        let currentRowCount = res.data.data.totalCount - pageNo * limit;
        currentRowCount > 0 ? setNextPage(true) : setNextPage(false);
        // if(rows.length + appendRows.length === res.data.data.totalCount) {
        //   setNextPage(false)
        //   setDataLoaded(true)
        // }
        props.updateNotificationNumber(res.data.data.unReadCount || 0);

        setLoading(true);
        setProgressBar(false);
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        setLoading(true);
        setProgressBar(false);
      },
      showPopUp: false
    };
    props.makeAPICall(apiCallParam);
  };

  const clearParticularNotifi = (e, notificationId, rowIndex) => {
    e.stopPropagation();
    let apiCallParam = {
      reqType: "post",
      reqURL: clearParticularNotification,
      dataObj: { notificationId: notificationId },
      params: {},
      headers: {},
      successCallback: res => {
        // console.log(rowIndex);
        let tmpRows = [...rows];
        tmpRows.splice(rowIndex, 1);
        setRows(tmpRows);


        setDataLoaded(true);

        // getNotifications(limit, skipPrevData);
        // update un Read count of notification in nav
        props.updateNotificationNumber(res.data.data.unReadCount || 0);
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
      },
      showPopUp: false
    };
    props.makeAPICall(apiCallParam);
  };

  const routeToTickets = (isTicket, ticketId) => {
    // if (isTicket && isTicket === true) {
    //   history.push(appRoutes.tickets);
    // }
    if(isTicket && isTicket === true && ticketId) {
      history.push(appRoutes.editTicket + "/" + ticketId, { _id: ticketId });
    }
  };


  useEffect(() => {
    console.log("Testing here Loaded");
    getNotifications(limit, skipPrevData);
  }, []);

  useEffect(() => {
    console.log("rows changed dataLoaded, rows, pageNo ", dataLoaded, rows, pageNo);
  }, [rows])

  useEffect(() => {
    if (props.clear && props.isEnableClear) {
      console.log("Testing here On Clear");
      setRows([]);
      setDataLoaded(true);
    }
  }, [props.clear]);

  return (
    <ul className="list-group list-group-flush border notification-list-ul">
      {/* Loop to print the notifications */}

      {rows.map((data, index) => {
        /*
         * If it is last element then take the referent to call an API Else print another block
         */

        if (rows.length === index + 1) {
          return (
            <li
              onClick={() => routeToTickets(data.isTicket, data.ticketId)}
              className={
                (dataLoaded && !rows.length) ||
                (dataLoaded && rows.length === limit) ||
                (dataLoaded && pageNo > 1)
                  ? "list-group-item border-bottom-0"
                  : "list-group-item border-bottom-0"
              }
              ref={lastElementRef}
              key={index}
            >
              <div className="notification-icon-div mt-1">
                <img
                  src={SmallLogo}
                  alt="Small-Logo-Notificaiton"
                  className="notification-icon"
                />
              </div>
              <div className="info-div col-sm-10">
                <Label
                  className="font-15 secondary-font gray w-100 p-0 m-0"
                  title={data.notificationMsg}
                />
                <Label
                  className="font-15 gray p-0 m-0"
                  title={moment(data.notificationDate).format("DD MMM YYYY hh:mm a")}
                />
              </div>
              {
                props.isEnableClear ? (
                  <div className="">
                    <ICButton
                      title="Done"
                      className="gray small gray-outline"
                      clickEvent={e => clearParticularNotifi(e, data._id, index)}
                    />
                  </div>
                ) : ('')
              }
            </li>
          );
        } else {
          return (
            <li
              className="list-group-item"
              key={index}
              onClick={() => routeToTickets(data.isTicket, data.ticketId)}
            >
              <div className="notification-icon-div mt-1">
                <img
                  src={SmallLogo}
                  alt="Small-Logo-Notificaiton"
                  className="notification-icon"
                />
              </div>
              <div className="info-div col-sm-10">
                <Label
                  className="font-15 secondary-font gray w-100 p-0 m-0"
                  title={data.notificationMsg}
                />
                <Label
                  className="font-15 gray p-0 m-0"
                  title={moment(data.notificationDate).format("DD MMM YYYY hh:mm a")}
                />
              </div>
              {
                props.isEnableClear ? (
                  <div className="">
                    <ICButton
                      title="Done"
                      className="gray small gray-outline"
                      clickEvent={e => clearParticularNotifi(e, data._id, index)}
                    />
                  </div>
                ) : ('')
              }
            </li>
          );
        }
      })}

      {/*
       * Progress bar on loading of notifications
       */}

      <li
        className={progressBar ? "list-group-item text-center p-4" : "d-none"}
      >
        <CircularProgress disableShrink className="primary-loader" />
      </li>

      {/*
       * No data fount if there are no data in notification array in API or clear btn clicked
       */}

      <li
        className={
          (dataLoaded && !rows.length) ||
          (dataLoaded && rows.length === limit) ||
          (dataLoaded && pageNo > 1)
            ? "list-group-item text-center p-4 border-bottom-0 border-top-0"
            : "d-none"
        }
      >
        <Label title="No data found" className="w-100 text-center" />
      </li>
    </ul>
  );
}

// export default function StickyHeadTable(props) {
//   const history = useHistory();
//   const observer = useRef(); // to check it is the last element or not - if it is last element then call an API
//   const [pageNo, setPageNumber] = useState(1); // just set page number if needed in future.
//   const [nextPage, setNextPage] = useState(false); // set next page if there is more data
//   const [loading, setLoading] = useState(true); // loading variable used to reduce multiple API calls
//   const [progressBar, setProgressBar] = useState(false); // progress bar hide and show
//   const [limit, setLimit] = useState(15); // limit is fixed but if we need to change in future then change it here
//   const [skip, setSkip] = useState(0); // set Skip page
//   const [noMoreData, setNoMoreData] = useState(false); // no data found block hide-show

//   // Data to be appended
//   const [rows, setRows] = useState([]); // setting rows
//   // const [appendRows, setAppendRows] = useState([]); // not used for now (if needed in future)

//   /*
//    * Check last element is visible or not
//   */
//   const lastElementRef = useCallback(node => {
//     if (observer.current) observer.current.disconnect();
//     observer.current = new IntersectionObserver(data => {
//       if (data) {
//         if (data[0].isIntersecting && nextPage && loading) {
//           setProgressBar(true);
//           setLoading(false);
//           if (loading) {
//             let skipCalculate = limit * pageNo,
//             currentPageNo = pageNo + 1;
//             setPageNumber(currentPageNo);
//             setSkip(skipCalculate);
//             getAllNotifications(limit, skipCalculate, currentPageNo);
//           }
//           setTimeout(() => {
//             setLoading(true);
//           }, 2000);
//           setTimeout(() => {
//             setProgressBar(false);
//           }, 1000);
//         }
//       }
//     });
//     if (node) observer.current.observe(node);
//   }, []);

//   /*
//   * Main function to call an API
//   * Pass parameters compulusry (limit, skipPage, currentPage) to calculate pagination
//   */

//   const getAllNotifications = useCallback((limitPage, skipPage, currentPage) => {
//     let apiCallParam = {
//       reqType: "GET",
//       reqURL: doctorNotifications,
//       dataObj: {},
//       params: {
//         limit: limitPage,
//         skip: skipPage
//       },
//       headers: {},
//       successCallback: res => {
//         // calculate is there any next page or not ?
//         let currentRowCount = res.data.data.totalCount - (currentPage * limitPage);
//         if (currentRowCount > 0) {
//           setNextPage(true);
//         } else {
//           setNextPage(false);
//           setNoMoreData(true);
//           setProgressBar(false);
//         }

//         // set the data
//         if (skipPage === 0) {
//           setRows(res.data.data.notifications);
//         } else {
//           setRows(prev => prev.concat(res.data.data.notifications));
//         }

//         // update un Read count of notification in nav
//         props.updateNotificationNumber(res.data.data.unReadCount || 0);
//       },
//       failureCallback: err => {
//         console.log("Something went wrong. Please try again ", err);
//       },
//       showPopUp: false
//     };
//     props.makeAPICall(apiCallParam);
//   }, []);

//   useEffect(() => {
//     // if clear btn clicked
//     if (props.clear) {
//       setSkip(0);
//       getAllNotifications(limit, 0, 0);
//     } else {
//       getAllNotifications(limit, skip, pageNo);
//     }
//   }, [props.clear]); // watch on clear btn

//   const clearParticularNotifi = (e ,notificationId, rowIndex) => {
//     e.stopPropagation()
//     let apiCallParam = {
//       reqType: "post",
//       reqURL: clearParticularNotification,
//       dataObj: {notificationId: notificationId},
//       params: {},
//       headers: {},
//       successCallback: res => {
//         const tmpRows = [...rows]
//         tmpRows.splice(rowIndex, 1)
//         setRows(tmpRows)
//         // update un Read count of notification in nav
//         props.updateNotificationNumber(res.data.data.unReadCount || 0);
//       },
//       failureCallback: err => {
//         console.log("Something went wrong. Please try again ", err);
//       },
//       showPopUp: false
//     };
//     props.makeAPICall(apiCallParam);
//   }

//   const routeToTickets = (isTicket) => {
//     if(isTicket && isTicket === true) {
//       history.push(appRoutes.tickets)
//     }
//   }

//   return (
//     <ul className="list-group list-group-flush border notification-list-ul">

//       {/* Loop to print the notifications */}

//       {rows.map((data, index) => {

//         /*
//          * If it is last element then take the referent to call an API Else print another block
//         */

//         if (rows.length === index + 1) {
//           return (
//             <li onClick={() => routeToTickets(data.isTicket)} className={(noMoreData && !rows.length) || (noMoreData && rows.length === limit) || (noMoreData && pageNo > 1) ? 'list-group-item border-bottom-0' : 'list-group-item border-bottom-0' } ref={lastElementRef} key={index}>
//               <div className="notification-icon-div mt-1">
//                 <img
//                   src={SmallLogo}
//                   alt="Small-Logo-Notificaiton"
//                   className="notification-icon"
//                 />
//               </div>
//               <div className="info-div col-sm-10">
//                 <Label
//                   className="font-15 secondary-font gray w-100 p-0 m-0"
//                   title={data.notificationMsg}
//                 />
//                 <Label
//                   className="font-15 gray p-0 m-0"
//                   title={moment(data.notificationDate).format("DD MMM YYYY")}
//                 />
//               </div>
//               <div className="text-right">
//                 <ICButton
//                 title="Clear"
//                 className="gray small gray-outline"
//                 clickEvent={(e)=>clearParticularNotifi(e, data._id, index)}
//                 />
//              </div>
//             </li>
//           );
//         } else {
//           return (
//             <li className="list-group-item" key={index} onClick={() => routeToTickets(data.isTicket)}>
//               <div className="notification-icon-div mt-1">
//                 <img
//                   src={SmallLogo}
//                   alt="Small-Logo-Notificaiton"
//                   className="notification-icon"
//                 />
//               </div>
//               <div className="info-div col-sm-10">
//                 <Label
//                   className="font-15 secondary-font gray w-100 p-0 m-0"
//                   title={data.notificationMsg}
//                 />
//                 <Label
//                   className="font-15 gray p-0 m-0"
//                   title={moment(data.notificationDate).format("DD MMM YYYY")}
//                 />
//               </div>
//               <div className="text-right">
//                 <ICButton
//                 title="Clear"
//                 className="gray small gray-outline"
//                 clickEvent={(e)=>clearParticularNotifi(e, data._id, index)}
//                 />
//              </div>
//             </li>
//           );
//         }
//       })}

//       {/*
//         * Progress bar on loading of notifications
//       */}

//       <li
//         className={progressBar ? "list-group-item text-center p-4" : "d-none"}
//       >
//         <CircularProgress disableShrink className="primary-loader" />
//       </li>

//       {/*
//         * No data fount if there are no data in notification array in API or clear btn clicked
//       */}

//       <li className={(noMoreData && !rows.length) || (noMoreData && rows.length === limit) || (noMoreData && pageNo > 1) ? "list-group-item text-center p-4 border-bottom-0 border-top-0" : "d-none"}>
//         <Label title="No data found" className="w-100 text-center" />
//       </li>
//     </ul>
//   );
// }
